// Replicates the value-parsing that v1 `@base` Input did internally (uppercase / number-abs / tel-digits-only)
// so swapping to the v2 `@baseV2` Input — which fires raw DOM events — keeps identical business behavior.

import { strings } from '@constants'

export const parseNumberValue = (e) => {
	const value = e.target.value ?? ''
	return value === '' ? value : Math.abs(value)
}

export const numberChangeHandler = (setValue) => (e) => {
	setValue(parseNumberValue(e))
}

export const uppercaseTrimmedChangeHandler = (setValue) => (e) => {
	setValue((e.target.value ?? '').toUpperCase().trim())
}

export const plainChangeHandler = (setValue) => (e) => {
	setValue(e.target.value ?? '')
}

// Quantity column/field label for every input type (weight, pieces, length, set, power, number).
export const weightLabel = () => strings('quantity')

export const buildUnknownProductRow = (name, rowId) => ({
	product_id: name,
	product_name: name,
	grade: '',
	required_weight: '',
	target_price: '',
	message: '',
	is_unknown_product: true,
	_rowId: rowId,
})

const normalizeGrade = (grade) => (grade ?? '').toString().trim().toUpperCase()

// Same product + same grade is a duplicate; when grade is empty on both sides, same
// product alone is enough (normalizeGrade collapses null/undefined/'' to one value).
export const isSameProductGrade = (a, b) => a?.product_id === b?.product_id && normalizeGrade(a?.grade) === normalizeGrade(b?.grade)

// Finds an already-saved enquiry item matching this candidate's product+grade, excluding
// the item currently being edited (pass its original item_id as excludeItemId).
export const findDuplicateEnquiryItem = (candidate, items, excludeItemId) =>
	(items ?? []).find((item2) => item2.item_id !== excludeItemId && isSameProductGrade(candidate, item2))

// Returns the set of `_rowId`s that repeat an earlier active row's product_id + grade
// (grade optional — empty-grade rows count as matching each other for the same product).
// Only rows with a required_weight entered are considered "active"; untouched blank rows
// (e.g. a just-added grade row before the user fills it in) never collide.
export const getDuplicateGradeRowIds = (rows = []) => {
	const seen = new Set()
	const duplicates = new Set()
	;(rows ?? [])
		.filter((row) => row?.required_weight !== '')
		.forEach((row) => {
			const key = `${row?.product_id}||${normalizeGrade(row?.grade)}`
			if (seen.has(key)) {
				duplicates.add(row?._rowId)
			} else {
				seen.add(key)
			}
		})
	return duplicates
}
